import { extractBundlePdfData, } from './extract_bundle_pdf_data';
import { generateSignedPdf } from './generate_signed_pdf';
const storedSignatureCount = (document) => {
    const signatures = document.ec__signatures;
    return Array.isArray(signatures) ? signatures.length : (signatures?.data?.length ?? 0);
};
/**
 * Builds a downloadable/printable ICF PDF from the Studio bundle, stamping
 * committed signatures when geometry is present.
 *
 * Returns undefined (caller toasts) when a signed or complete ICF has no overlay
 * geometry to stamp — the baker refuses that same cell rather than emitting a
 * blank template as a "copy". Unsigned in-progress documents still return the
 * raw bundle.
 */
export async function buildConsentCopyPdfBytes(document, summaries, locale, enteredDates = [], enteredTexts = [], enteredChoices = []) {
    const bundleUrl = document.ec__published_studio_template?.ec__bundle?.url;
    if (!bundleUrl) {
        return undefined;
    }
    const { pdfBytes, signedOverlays, dateOverlays, textOverlays, choiceOverlays = [], } = await extractBundlePdfData(bundleUrl, summaries, enteredDates, enteredTexts, enteredChoices);
    const hasStoredSignatures = storedSignatureCount(document) > 0 || document.ec__status === 'complete';
    // Dates, free-text answers and selected choices all count as something to stamp: a document whose
    // only field is one of those completes with no signature overlay at all, and refusing it here
    // would leave it permanently undownloadable.
    const nothingToStamp = signedOverlays.length === 0 &&
        dateOverlays.length === 0 &&
        textOverlays.length === 0 &&
        choiceOverlays.length === 0;
    if (nothingToStamp && (hasStoredSignatures || summaries.length > 0)) {
        return undefined;
    }
    if (nothingToStamp) {
        return pdfBytes;
    }
    return generateSignedPdf({
        pdfBytes,
        signatures: signedOverlays,
        dates: dateOverlays,
        texts: textOverlays,
        choices: choiceOverlays,
        locale,
    });
}
